/* ═══════════════════════════════════════════════════
   TrackLab v2 — Race Progress Bar
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  TL.progress = {};

  /**
   * Calculate percentage complete from timing data.
   */
  function _calcPct(startIso, offIso, duration) {
    if (!startIso) return -1;
    var now = Date.now();
    var raceStart = offIso ? new Date(offIso).getTime() : new Date(startIso).getTime() + 30000;
    var elapsed = (now - raceStart) / 1000;
    return Math.max(0, Math.min(100, (elapsed / duration) * 100));
  }

  /**
   * Format seconds remaining as m:ss or --:--.
   */
  function _formatRemaining(startIso, offIso, duration) {
    if (!startIso) return '--:--';
    var now = Date.now();
    var raceStart = offIso ? new Date(offIso).getTime() : new Date(startIso).getTime() + 30000;
    var elapsed = (now - raceStart) / 1000;
    var remaining = Math.max(0, duration - elapsed);
    var mins = Math.floor(remaining / 60);
    var secs = Math.floor(remaining % 60);
    return mins + ':' + (secs < 10 ? '0' : '') + secs;
  }

  /**
   * Update expanded race view progress bar.
   */
  TL.progress.update = function (raceId) {
    if (!raceId) return;
    var exp = document.getElementById('v2Expanded-' + raceId);
    if (!exp) return;
    var track = document.getElementById('v2Track-' + raceId);
    if (!track) return;

    var pct = _calcPct(exp.dataset.raceStart, exp.dataset.offTime, parseInt(exp.dataset.duration) || 120);
    if (pct < 0) return;

    var fill = track.querySelector('.progress-fill');
    var label = track.querySelector('.pct-label');
    if (fill) fill.style.width = Math.round(pct) + '%';
    if (label) {
      label.textContent = Math.round(pct) + '%';
      label.style.left = Math.round(pct) + '%';
    }
  };

  /**
   * Update ALL live banner progress bars and countdowns.
   * Iterates every .live-banner in the DOM (supports multiple simultaneous live races).
   */
  TL.progress.updateBanners = function () {
    var banners = document.querySelectorAll('.live-banner');
    banners.forEach(function (banner) {
      var track = banner.querySelector('.lb-track');
      var startIso = banner.dataset.raceStart;
      var offIso = banner.dataset.offTime;
      var duration = parseInt(banner.dataset.duration) || 120;

      // Update progress bar
      if (track) {
        var pct = _calcPct(startIso, offIso, duration);
        if (pct >= 0) {
          var fill = track.querySelector('.lb-progress-fill');
          var label = track.querySelector('.lb-pct');
          if (fill) fill.style.width = Math.round(pct) + '%';
          if (label) {
            label.textContent = Math.round(pct) + '%';
            label.style.left = Math.round(pct) + '%';
          }
        }
      }

      // Countdown text is handled by countdown.js (has richer walk-to-post logic)
    });
  };

  // Backwards compat alias
  TL.progress.updateBanner = TL.progress.updateBanners;

  // Tick every second
  setInterval(function () {
    // Expanded view progress
    if (TL.state.activeRaceId) TL.progress.update(TL.state.activeRaceId);
    // Live banner progress (all banners)
    TL.progress.updateBanners();
  }, 1000);
})();
